import React from 'react'
import { ImageMarker } from 'src/components/mapMarkers/ImageMarker'
import { IMarkerProps } from 'src/components/mapMarkers/MapMarkerProps'
import { SvgIcon, SvgIconWrapper } from 'src/components/SvgIconWrapper'
import {
  ANDROID_ANCHOR,
  mapMarkerStyles,
  PICKUP_DROPOFF_PIN_OFFSET,
  PICKUP_DROPOFF_PIN_SIZE,
} from 'src/helpers/MapMarkerHelper'
import { IMarker, MarkerTypes } from 'src/types'

export const PickupPinMarker = (props: IMarkerProps) => {
  const pickupPinMarker: IMarker = {
    name: MarkerTypes.PickupPin,
    coordinate: props.location,
    anchor: ANDROID_ANCHOR,
    imageStyle: mapMarkerStyles.pickupDropoffPin,
    webCenterOffset: { offsetLeft: -PICKUP_DROPOFF_PIN_OFFSET, offsetTop: -PICKUP_DROPOFF_PIN_OFFSET },
    child: (
      <SvgIconWrapper
        icon={SvgIcon.PickupPin}
        widthFixed={PICKUP_DROPOFF_PIN_SIZE}
        heightFixed={PICKUP_DROPOFF_PIN_SIZE}
      />
    ),
  }
  return <ImageMarker {...pickupPinMarker} />
}
